<template>
    <div class="absolute w-72 z-40" style="
    bottom: 67px;
    width: 344px;
    right: 14px;
" dir="ltr">
        <div class="p-1 rounded-md shadow-xl bg-gray-200" v-if="loaded">
            <div  v-if="!user" class="bg-light flex flex-col h-full">
                    <div class="flex w-full p-2 bg-white items-center justify-between">
                        <span style="width: calc(100% - 3rem);" class="flex flex-1 flex-col items-start px-2 box-border">
                            <span class="flex justify-between w-full">
                                <h3 class="text-xl font-bold text-primary">{{ 'COD Support'|t }}</h3>
                            </span>
                        </span>
                        <!-- Close button -->
                        <button @click="$emit('close')" class="flex items-center justify-center bg-transparent rounded-full border-0 cursor-pointer text-danger h-8 w-8">
                            X
                        </button>
                    </div>
                    <div class="w-full flex items-center justify-between flex-col" style="min-height: 220px; max-height: 320px;background-color: #dddddd;background-image: url('https://storeno.b-cdn.net/managers/5-2022/1653126948822.png');background-size: contain;background-repeat: repeat;">
                        <div class="flex flex-col w-full py-2">
                            <div class="flex w-full flex-col message-from-admin" v-for="msg in ['Hi how we can help you', 'Salut comment pouvons-nous vous aider']" :key="msg" style="max-width:90%;">
                                <div class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                    <div class="flex px-2 gap-2">
                                        <img src="https://storeno.b-cdn.net/eship/favicon-32x32.png" class="rounded-full w-8 h-8">
                                        <div dir="auto" class="p-2 content-from-admin">{{ msg }}</div>
                                    </div>
                                    <div class="text-sm px-8 bg-grey bg-opacity-25 flex justify-between items-center message-sender">
                                        <span class="text-xs">{{ $moment().format('hh:mm A') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="w-full bg-white pt-3 pb-2 flex justify-center">
                            <button color="primary"  @click="startConversation(true)">{{ 'Start conversation' }}</button>
                        </div>
                    </div>
            </div>
            <div v-else class="flex flex-col h-full" style="background-color: #dddddd;background-image: url('https://storeno.b-cdn.net/managers/5-2022/1653126948822.png');background-size: contain;background-repeat: repeat;">
                <div class="flex w-full p-2 bg-white items-center justify-between">
                    <span style="width: calc(100% - 3rem);" class="flex flex-1 flex-col items-start px-2 box-border">
                        <span class="flex justify-between w-full">
                            <h3 class="text-xl font-bold text-primary">{{ 'Support'|t }}</h3>
                        </span>
                    </span>
                    <!-- Close button -->
                    <button @click="$emit('close')" class="flex items-center justify-center bg-transparent rounded-full border-0 cursor-pointer text-danger h-8 w-8">
                        X
                    </button>
                </div>
                <!-- messages list -->
                <div class="w-full h-full flex-1 overflow-auto px-1" id="popup-scroll-box" style="min-height: 220px; max-height: 320px;">
                    <template v-if="messages.length == 0">
                        <div class="flex w-full flex-col message-from-admin" v-for="msg in ['Hi how we can help you', 'Salut comment pouvons-nous vous aider']" :key="msg" style="max-width:90%;">
                            <div class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                <div class="flex px-2 gap-2">
                                    <img src="https://storeno.b-cdn.net/eship/favicon-32x32.png" class="rounded-full w-8 h-8">
                                    <div dir="auto" class="p-2 content-from-admin">{{ msg }}</div>
                                </div>
                                <div class="text-sm px-8 bg-grey bg-opacity-25 flex justify-between items-center message-sender">
                                    <span class="text-xs">{{ $moment().format('hh:mm A') }}</span>
                                </div>
                            </div>
                        </div>
                    </template>
                    <div class="flex flex-col w-full" v-for="(message,i) in messages" :key="message.key">
                        <!-- Show day if different -->
                        <div v-if="i == 0 || $moment(Number(message.key)).format('D MMM') != $moment(Number(messages[i-1].key)).format('D MMM')" class="flex justify-between items-center w-full my-2">
                            <span style="border-bottom:2px solid #ffffff" class="flex-grow shadow"></span>
                            <span class="text-secondary bg-white p-2 rounded-lg shadow-lg">{{ $moment(Number(message.key)).format('D MMM YYYY') }}</span>
                            <span style="border-bottom:2px solid #ffffff" class="flex-grow shadow"></span>
                        </div>
                        <div class="flex" :class="` message-from-${message.from}`">
                            <div :style="`${message.content.indexOf('iframe') != -1 ? 'width:100%':'max-width:90%;' }`" v-if="message.type == 'text'" class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                <div class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                    <div class="flex px-2 gap-2">

                                        <img v-if="message.from == 'admin'" 
                                         src="https://storeno.b-cdn.net/eship/favicon-32x32.png" class="rounded-full order-1 w-8 h-8">
                                        <div v-else 
                                         class="w-8 h-8 font-bold text-center text-white order-2 capitalize rounded-full bg-gray-500" >{{user && user.name.substring(0,1)}}</div>
                                        <div dir="auto" class="p-2 rounded-md" :class="`${message.from == 'admin' ?'order-2' : 'order-1'} content-from-${message.from}`" v-html="message.content"></div>
                                    </div>
                                    <div :class="message.from == 'admin' ? 'px-12': 'px-4'" class="text-sm bg-grey bg-opacity-25 flex justify-between items-center message-sender">
                                        <span class="text-xs">{{$moment(Number(message.key)).format('hh:mm A') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="max-width:90% !important" v-else-if="message.type == 'image'" class="w-full max-w-md rounded-lg my-2 overflow-hidden message-image">
                                <div class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                    <div class="flex px-2 gap-2">
                                        <img v-if="message.from == 'admin'" 
                                         src="https://storeno.b-cdn.net/eship/favicon-32x32.png" class="rounded-full order-1 w-8 h-8">
                                        <div v-else 
                                         class="w-8 h-8 font-bold text-center text-white order-2 capitalize rounded-full bg-gray-500" >{{user && user.name.substring(0,1)}}</div>
                                        <img :src="message.content" class="w-full px-1 rounded-lg pt-1" :class="`${message.from == 'admin' ?'order-2' : 'order-1'} content-from-${message.from}`" />
                                    </div>
                                    <div :class="message.from == 'admin' ? 'px-12': 'px-4'" class="text-sm bg-grey bg-opacity-25 flex justify-between items-center message-sender">
                                        <span class="text-xs">{{$moment(Number(message.key)).format('hh:mm A') }}</span>
                                    </div>
                                </div>
                            </div>
                            <div style="max-width:90%" v-else-if="message.type == 'audio'" class="w-full max-w-md rounded-lg my-2 overflow-hidden message-audio">
                                <div class="flex flex-col overflow-hidden relative rounded-lg my-2 message-text">
                                    <div class="flex px-2 gap-2">
                                        <img v-if="message.from == 'admin'" 
                                         src="https://storeno.b-cdn.net/eship/favicon-32x32.png" class="rounded-full order-1 w-8 h-8">
                                        <div v-else 
                                         class="w-8 h-8 font-bold text-center text-white order-2 capitalize rounded-full bg-gray-500" >{{user && user.name.substring(0,1)}}</div>
                                        <audio controls class="w-full px-1 rounded-lg pt-1" :class="`${message.from == 'admin' ?'order-2' : 'order-1'} content-from-${message.from}`" style="background-color: transparent !important;" :src="message.content"></audio>
                                    </div>
                                    <div :class="message.from == 'admin' ? 'px-12': 'px-4'" class="text-sm bg-grey bg-opacity-25 flex justify-between items-center message-sender">
                                        <span class="text-xs">{{$moment(Number(message.key)).format('hh:mm A') }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div v-if="sending" class="flex relative bg-white items-center justify-center p-2">
                    <span>Sending...</span>
                </div>
                <div v-else class="flex relative bg-white items-center">
                    <!-- message input -->
                    <div v-if="image || audio || mediaRecorder" class="flex justify-between items-center absolute bg-white p-1 w-full bottom-0 z-10" >
                        <!-- image base64 -->
                        <div class="w-32 h-32 absolute bottom-0 m-1 p-2 bg-white rounded-lg" style="left:0" v-if="image">
                            <img class="w-full h-full object-cover rounded-lg" :src="image">
                        </div>
                        <span v-if="image"></span>
                        <!-- audio base64 -->
                        <div v-if="mediaRecorder" class=" bg-black rounded-lg w-full relative flex justify-center items-center bg-contain" :style="recordingState == 'recording' ? `background-image:url('https://storeno.b-cdn.net/managers/5-2022/1652470773713.gif')` : ''">
                            <!-- Recording audio -->
                            <small class=" text-xs text-white bottom-0 p-1 absolute capitalize" style="left:0">{{ recordingState }}</small>
                            <button class="bg-white text-danger w-16 h-10 text-xs flex justify-center items-center rounded-full border-2 cursor-pointer border-white border-solid" v-if="recordingState == 'recording'" @click="mediaRecorder.stop()"><span>{{ 'Stop' }}</span></button>
                            <small class=" text-xs text-white bottom-0 p-1 absolute" style="right:0">{{ recordingTime }}</small>
                        </div>
                        <!-- audio base64 -->
                        <div v-if="audio" class="flex w-full items-center p-1">
                            <audio controls class="w-full h-10" preload="auto" id="audioRecord">
                                <source :src="audio" type="audio/mpeg">
                            </audio>
                        </div>
                        <div class="flex justify-center p-1">
                            <button v-if="audio" @click="audio = null" class="flex items-center justify-center bg-blue-500 text-white rounded border-0 cursor-pointer bg-danger h-10 w-10">
                                X
                            </button>
                            <button v-if="image" @click="image = null" class="flex items-center justify-center bg-blue-500 text-white rounded border-0 cursor-pointer bg-danger h-10 w-10">
                                X
                            </button>
                            <span class="mr-1"></span>
                            <div @click="sendMessage" class="flex-none" v-if="!mediaRecorder">
                                <button class="flex items-center justify-center bg-blue-500 text-white rounded border-0 cursor-pointer bg-success h-10 w-10">
                                    <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                    />
                  </svg>
                                </button>
                            </div>
                        </div>
                    </div>
                    <form @submit.prevent="sendMessage" class="flex w-full p-1 items-center">
                        <!-- image -->
                        <!-- message -->
                        <div class="flex-1">
                            <input v-model="message.content" class="w-full border-0 p-2 h-full" placeholder="Type your message here">
                        </div>
                        <div class="flex-none">
                            <button type="button" @click="setImage" class="flex items-center justify-center text-gray-600 rounded-full border-0 cursor-pointer hover:bg-gray-400 h-10 w-10">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  fill="none"
                                  viewBox="0 0 24 24"
                                  stroke-width="1.5"
                                  stroke="currentColor"
                                  class="w-6 h-6"
                                >
                                  <path
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                    d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13"
                                  />
                                </svg>
                            </button>
                        </div>
                        <!-- Audio -->
                        <div class="flex-none">
                <button
                  type="button"
                  @click="startAudio"
                  class="flex items-center justify-center text-gray-600 rounded-full border-0 cursor-pointer hover:bg-gray-400 h-10 w-10"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M12 18.75a6 6 0 0 0 6-6v-1.5m-6 7.5a6 6 0 0 1-6-6v-1.5m6 7.5v3.75m-3.75 0h7.5M12 15.75a3 3 0 0 1-3-3V4.5a3 3 0 1 1 6 0v8.25a3 3 0 0 1-3 3Z"
                    />
                  </svg>
                </button>
              </div>
              <span class="mr-1"></span>
              <!-- Send button -->
              <div class="flex-none">
                <button
                  class="flex items-center justify-center bg-blue-500 text-white rounded-md border-0 cursor-pointer bg-primary h-10 w-10"
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    class="w-6 h-6"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      d="M6 12 3.269 3.125A59.769 59.769 0 0 1 21.485 12 59.768 59.768 0 0 1 3.27 20.875L5.999 12Zm0 0h7.5"
                    />
                  </svg>
                </button>
              </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'chat-popup',
    props: {
        info: {
            type: Object,
            default: { shown: false, unread: 0}
        },
    },
    data() {
        return {
            sending: false,
            loaded: false,
            firebase: null,
            messages: [],
            message: {
                content: "",
                type: "text",
                seen: false,
                from: "user"
            },
            image: null,
            audio: null,
            user: null,
            refs: { users: null, messages: null },
            mediaRecorder: null,
            recordingState: '',
            recordingTime: '00:00',
            country: 'US',
            notify: new Audio(require('@/assets/ringtone/noti.wav')),
            stores: [],
        };
    },
    async mounted() {
       console.log("Start Mounted Popup");
        await this.initFirebase();
        if(!this.firebase) return alert("Firebase not initialized Popup");
        await this.getUser();
        console.log("End Mounted Popup");
        
    },
    methods: {
        async initFirebase() {
      return new Promise((resolve, reject) => {
        let firebasecdn = document.createElement("script");
        let databasecdn = document.createElement("script");
        let fbauthcdn = document.createElement("script");
        let cryptoAES = document.createElement("script");
        firebasecdn.src =
          "https://www.gstatic.com/firebasejs/7.17.1/firebase-app.js";
        databasecdn.src =
          "https://www.gstatic.com/firebasejs/7.17.1/firebase-database.js";
        fbauthcdn.src =
          "https://www.gstatic.com/firebasejs/7.17.1/firebase-auth.js";
        cryptoAES.src =
          "https://cdnjs.cloudflare.com/ajax/libs/crypto-js/3.1.2/rollups/aes.js";
        document.head.appendChild(firebasecdn);
        firebasecdn.onload = () => {
          console.log("Firebase Loaded");
          document.head.appendChild(databasecdn);
          databasecdn.onload = () => {
            console.log("Database Loaded");
            document.head.appendChild(fbauthcdn);
            fbauthcdn.onload = () => {
              console.log("Auth Loaded");
              document.head.appendChild(cryptoAES);
              cryptoAES.onload = async () => {
                console.log("Crypto Loaded");
                let secret = null;
                let decryptedPack = {};
                let fbdecryptedPack = {};
                secret =
                  "LTNbckMnVTBjUD1BXVZXLn4sWHh+YUA=TVs0bWwzL18rMSw7ZUJgXGtVQmtFTA==a2Z4KypyNWcrPixeMHlNLyhjczdrMH5lfDIpRA==e0EhdU4pUUxeRlUsTCVzUVorZg==";
                let cryptedPack = {
                  email:
                    "U2FsdGVkX1/c5TVVPpaXiL7bwEMcEvJQFvyYZAVzMvn1c0kldODjuDBpVG+0FrzO",
                  password:
                    "U2FsdGVkX19Gl3dJrn0XrJr9HcvTLQaLC1Qv9aEyZlSuzYrS4ucxtZxl8C7b1x42swtz1PmuV8iO2VLtaEbm6g==",
                };
                let fbcryptedPack = {
                  apiKey: "AIzaSyD1MPTM3jpsmiAdnbuUU3sBNhOLAGRWNZw",
                  authDomain: "eshipi-chatlive.firebaseapp.com",
                  projectId: "eshipi-chatlive",
                  storageBucket: "eshipi-chatlive.appspot.com",
                  messagingSenderId: "734427857229",
                  appId: "1:734427857229:web:860f818cc4244b72d1f704",
                  databaseURL:"https://eshipi-chatlive-default-rtdb.firebaseio.com"
                };
                // decryptedPack.email = CryptoJS.AES.decrypt(
                //   cryptedPack.email,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // decryptedPack.password = CryptoJS.AES.decrypt(
                //   cryptedPack.password,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.apiKey = CryptoJS.AES.decrypt(
                //   fbcryptedPack.apiKey,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.authDomain = CryptoJS.AES.decrypt(
                //   fbcryptedPack.authDomain,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.databaseURL = CryptoJS.AES.decrypt(
                //   fbcryptedPack.databaseURL,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.projectId = CryptoJS.AES.decrypt(
                //   fbcryptedPack.projectId,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.storageBucket = CryptoJS.AES.decrypt(
                //   fbcryptedPack.storageBucket,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.messagingSenderId = CryptoJS.AES.decrypt(
                //   fbcryptedPack.messagingSenderId,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                // fbdecryptedPack.appId = CryptoJS.AES.decrypt(
                //   fbcryptedPack.appId,
                //   secret
                // ).toString(CryptoJS.enc.Utf8);
                if (firebase.apps && firebase.apps.length == 0)
                  await firebase.initializeApp(fbcryptedPack);
                console.log("Firebase Initialized");
                this.firebase = firebase;
                // firebase.auth().signInWithEmailAndPassword(decryptedPack.email,decryptedPack.password).then((userCredential) => {
                //     console.log("Logged In 1");
                // }).catch((error) => console.log(error));
                // firebase.auth().onAuthStateChanged((user) => { if (user) {
                //     console.log("Logged In 2");
                //     resolve(user.uid);
                // } else {
                //     console.log("Error Logged In 3");
                // } });
                    resolve("Firebase Initialized");
              };
            };
          };
        };
      });
    },
        async startConversation(create = false){
            const key = this.$store.state.user._id;
            this.firebase.database().ref('users/'+key).once('value').then((snapshot) => {
            const content = snapshot.val();
            this.user = { key: snapshot.key, ...content }; // what that
            if(!content){
                this.firebase.database().ref('users/'+key).set({
                    lastActivity:1652449801371,
                    lastFrom:"user",
                    typeUser:this.$store.state.user.type,
                    lastMessage:"No Message",
                    fullName: this.$store.state.user.fullName,
                    email: this.$store.state.user.email,
                });
                this.user = { key, ...{
                    lastActivity:1652449801371,
                    lastFrom:"user",
                    typeUser:this.$store.state.user.type,
                    lastMessage:"No Message",
                    fullName: this.$store.state.user.fullName,
                    email: this.$store.state.user.email,
                } }
            } else {
                console.log("User Created");
            }
        });

            this.messages = [];
            this.refs.messages = this.firebase.database().ref('conversations/' + key).orderByKey();
            this.refs.messages.on('child_added', (snapshot) => {
                const data = snapshot.val();
                if(data.type == 'text') data.content = data.content.replace(/(<([^>]+)>)/ig, "").replace(/&nbsp;/g, " ");
                // convert links
                if(data.type == 'text') data.content = this.convertLinks(data.content);
                this.messages.push({key: snapshot.key,...data});
                this.$nextTick(() => {
                    document.getElementById('popup-scroll-box').scrollTop = document.getElementById('popup-scroll-box').scrollHeight;
                });
                if(Number(snapshot.key) > (new Date().getTime() - 5000) && data.from == 'admin'){
                    console.log("New Message from admin");
                    this.notify.play();
                }
                this.info.unread = this.messages.filter((message) => message.from == 'admin' && message.seen == false).length;
            });
            this.refs.messages.on('child_changed', (snapshot) => {
                const index = this.messages.findIndex(message => message.key == snapshot.key);
                this.$set(this.messages, index, {key: snapshot.key,...snapshot.val()});
                this.$nextTick(() => {
                    document.getElementById('popup-scroll-box').scrollTop = document.getElementById('popup-scroll-box').scrollHeight;
                });
            });
            this.refs.messages.on('child_removed', (snapshot) => {
                const index = this.messages.findIndex(message => message.key == snapshot.key);
                this.messages.splice(index, 1);
                this.$nextTick(() => {
                    document.getElementById('popup-scroll-box').scrollTop = document.getElementById('popup-scroll-box').scrollHeight;
                });
            });
            
        },
        async getUser() {
            const key = this.$store.state.user._id;
            if(!key) return;
            this.firebase.database().ref('users/'+key).once('value').then((snapshot) => {
                this.loaded = true;
                const data = snapshot.val();
                if(data){
                    this.user = { key: snapshot.key, ...data };
                    this.startConversation();
                }
            });
        },
        async setImage(){
            const input = document.createElement('input');
            input.type = 'file';
            input.accept = 'image/*';
            input.onchange = (e) => {
                // base 64
                const file = e.target.files[0];
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.image = e.target.result;
                }
                reader.readAsDataURL(file);
            }
            input.click();
        },
        async startAudio() {
            console.log("Start Audio");
            // start audio recording audio stream using getUserMedia
            const stream = await navigator.mediaDevices.getUserMedia({audio: true});
            this.$set(this,'mediaRecorder', new MediaRecorder(stream));
            console.log(this.mediaRecorder);
            const audioChunks = [];
            this.mediaRecorder.addEventListener("dataavailable", event => {
                audioChunks.push(event.data);
            });
            this.$set(this,'recordingState', this.mediaRecorder.state);
            this.mediaRecorder.addEventListener("stop", () => {
                if(window.recordingInterval) clearInterval(window.recordingInterval);
                const blob = new Blob(audioChunks,{type: 'audio/mp3'});
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.onloadend = () => {
                    this.recordingState = null;
                    this.mediaRecorder = null;
                    this.audio = reader.result;
                    this.$nextTick(()=>{
                        const audioEl =  document.querySelector('#audioRecord');
                        audioEl.play();
                        this.$nextTick(()=>{
                            audioEl.pause();
                            audioEl.currentTime = 0;
                        });
                    });
                };
            });
            this.mediaRecorder.addEventListener("start", () => {
                console.log("Started");
                this.$set(this,'recordingState', "recording");
                window.startRecordingTime = Date.now();
                window.recordingInterval = setInterval(() => {
                    let minues = Math.floor((Date.now() - window.startRecordingTime) / 60000);
                    let seconds = Math.floor(((Date.now() - window.startRecordingTime) % 60000) / 1000);
                    if(minues < 10) minues = "0" + minues;
                    if(seconds < 10) seconds = "0" + seconds;
                    this.recordingTime = `${minues}:${seconds}`;
                },500);
            });
            this.mediaRecorder.start();
        },
        async sendMessage(){
            // add message to conversation / user
            this.sending = true;
            let content = this.message.content;
            let type = this.message.type;
            if(this.image){
                try {
                    const data = await this.$server.create("medias",   { src: this.image } );
                    content = data.content;
                    type = 'image';
                } catch (error) { console.log('err',error); }
            }
            if(this.audio){
                try {
                    const data = await this.$server.create("medias",   { src: this.audio } );
                    content = data.content;
                    type = 'audio';
                } catch (error) { console.log('err',error); }
            }
            this.firebase.database().ref('conversations/' + this.user.key).child((new Date()).getTime()).set({
                content: content,
                type: type,
                seen: false,
                from: "user",
                admin:this.$store.state.user.fullName,
            }).then(() => {
                this.message.content = '';
                this.image = null;
                this.audio = null;
                this.firebase.database().ref('users/' + this.user.key).update({
                    name: this.$store.state.user.fullName,
                    lastActivity: (new Date()).getTime(),
                    lastMessage: type == 'text' ? content : `[${type.toUpperCase()}]`,
                    lastFrom: "user",
                    unread: this.messages.filter((message) => message.from == 'user' && message.seen == false).length,
                }).then(() => {
                    console.log('message sent');
                }).catch((error) => {
                    console.log('err',error);
                });
                this.sending = false;
            }).catch(() => {
                this.sending = false;
            });
        },
         convertLinks(input){

            let text = input;
            const linksFound = text.match( /(?:www|https?)[^\s]+/g );
            const aLink = [];

            if ( linksFound != null ) {

                for ( let i=0; i<linksFound.length; i++ ) {
                let replace = linksFound[i];
                if ( !( linksFound[i].match( /(http(s?)):\/\// ) ) ) { replace = 'http://' + linksFound[i] }
                let linkText = replace.split( '/' )[2];
                if ( linkText.substring( 0, 3 ) == 'www' ) { linkText = linkText.replace( 'www.', '' ) }
                if ( linkText.match( /youtu/ ) ) {

                    let youtubeID = replace.split( '/' ).slice(-1)[0];
                    if(youtubeID.indexOf('=') > -1) youtubeID = youtubeID.split('=')[1];
                    aLink.push( '<div style="padding-bottom: 57%;width: 100%;position: relative;min-width: 260px;"><iframe style="position: absolute;width: 100%;height: 100%;" src="https://www.youtube.com/embed/' + youtubeID + '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>' )
                }
                else if ( linkText.match( /vimeo/ ) ) {
                    let vimeoID = replace.split( '/' ).slice(-1)[0];
                    aLink.push( '<div class="video-wrapper"><iframe src="https://player.vimeo.com/video/' + vimeoID + '" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe></div>' )
                }
                else {
                    aLink.push( '<a href="' + replace + '" target="_blank">' + linkText + '</a>' );
                }
                text = text.split( linksFound[i] ).map(item => { return aLink[i].includes('iframe') ? item.trim() : item } ).join( aLink[i] );
                }
                return text;

            }
            else {
                return input;
            }
        }
    },
    watch: {
        "info.shown"(val){
            if(val){
                this.messages.filter(message => message.seen == false && message.from == 'admin').forEach(message => {
                    this.firebase.database().ref('conversations/' + this.user.key + '/' + message.key).update({
                        seen: true,
                    }).then(() => {
                        message.seen = true;
                        this.info.unread = this.messages.filter(message => message.seen == false && message.from == 'admin').length;
                    });
                });
            }
        }
    }
}
</script>
<style>
    .livechat{
        font-family: 'Cairo', Helvetica, Arial, sans-serif !important;
    }
    .livechat *{
        font-family: 'Cairo', Helvetica, Arial, sans-serif !important;
    }
    audio#audioRecord::-webkit-media-controls-current-time-display,
    audio#audioRecord::-webkit-media-controls-time-remaining-display{
        display: none;
    }
    .message-from-user {justify-content: flex-end;}
    .message-from-admin {justify-content: flex-start;}
    .content-from-user {background: #FF0000; color: white}
    .content-from-admin { background: #ffff;}

    .message-from-user > div.message-audio,
    .message-from-admin > div.message-audio {
        max-width: 360px !important;
    }
    .message-from-user > div audio::-webkit-media-controls-play-button,
    .message-from-user > div audio::-webkit-media-controls-panel {
        background-color: #c5e1ad;
     }
     .message-from-admin > div audio{
        filter: invert(1)
     }
    .message-from-admin > div audio::-webkit-media-controls-play-button,
    .message-from-admin > div audio::-webkit-media-controls-panel {
        background-color: #d16c4a;
        
     }
     .message-from-user  a,
    .message-from-admin a {
        color: #fff !important;
        text-decoration: underline !important;
    }
</style>